import { render, staticRenderFns } from "./OrderNavigationHistory.vue?vue&type=template&id=be67d92e&"
import script from "./OrderNavigationHistory.vue?vue&type=script&lang=js&"
export * from "./OrderNavigationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports